import React, { useState, useEffect } from "react";
import Fuse from "fuse.js";

const SearchBar = () => {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [data, setData] = useState([]);

  useEffect(() => {
    // Fetch the search data JSON
    const fetchData = async () => {
      const res = await fetch("/search-data.json");
      const searchData = await res.json();
      setData(searchData);
    };
    fetchData();
  }, []);

  // Configure Fuse.js
  const fuse = new Fuse(data, {
    keys: ["title"], // Search by title
    threshold: 0.3,  // Adjust for fuzzy matching
  });

  const handleSearch = (e) => {
    const input = e.target.value;
    setQuery(input);

    if (input.trim() === "") {
      setResults([]);
      return;
    }

    const fuseResults = fuse.search(input, { limit: 5 });
    setResults(fuseResults.map(result => result.item));
  };

  return (
    <div className="position-relative">
      <input
        type="text"
        value={query}
        onChange={handleSearch}
        placeholder="Search ..."
        className="w-full p-2 border rounded"
        style={{ width: '100%'}}
      />
      {results.length > 0 && (
        <ul className="position-absolute w-full bg-white border rounded shadow">
          {results.map((result) => (
            <li key={result.id} className="p-2 hover:bg-gray-100 d-flex items-center">
              {result.image && (
                <img src={result.image} alt={result.title} style={{width: '70px', height: '70px', objectFit: 'cover', marginRight: '10px'}} className="w-10 h-10 mr-2" />
              )}
              <a href={result.slug} style={{textDecoration: 'none'}}>{result.title}</a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SearchBar;
